import { isValidEnumValue } from "./isValidEnumValue";

export const getDefaultEnumValue = <T extends { [key: string]: string }>(
  object: T,
  value: string,
  defaultValue: T[keyof T]
): T[keyof T] =>
  isValidEnumValue(object, value) ? (value as T[keyof T]) : defaultValue;
